import { formatBodyWeight, formatResultWeight } from '~/utils/weight';
import { useFilterForm } from '~/hooks/useFilterForm';
import { Table } from '~/components/Table/Table';
import { Link } from '~/components/Link/Link';
import { querySchema } from '../query-schema';
import { formatPoints } from '~/utils/points';
import { ResultRanking } from '~/apis/ssf';
import { formatDate } from '~/utils/date';
import { match } from 'ts-pattern';

interface Props {
  results: ResultRanking[];
  isLoading: boolean;
}

function Row({ result }: { result: ResultRanking }) {
  const { values } = useFilterForm(querySchema.parse);

  return (
    <Table.Row>
      <Table.Col>{result.rank_nr}</Table.Col>
      <Table.Col>
        <Link to={`/lifters/${result.person.id}`}>
          {result.person.first_name} {result.person.last_name}
        </Link>
      </Table.Col>
      <Table.Col>
        <Link to={`/clubs/${result.club.id}`}>{result.club.name}</Link>
      </Table.Col>
      <Table.Col>{formatBodyWeight(result.body_weight)}</Table.Col>
      <Table.Col>
        {match(values)
          .with({ discipline: 'points' }, () => formatPoints(result.result))
          .otherwise(() => formatResultWeight(result.result))}
      </Table.Col>
      <Table.Col>{result.group.start ? formatDate(new Date(result.group.start), 'yyyy-mm-dd') : '-'}</Table.Col>
    </Table.Row>
  );
}

export function RankingListTable({ results, isLoading }: Props) {
  return (
    <Table bg="even">
      <Table.Head>
        <Table.Row>
          <Table.Col as="th">#</Table.Col>
          <Table.Col as="th">Namn</Table.Col>
          <Table.Col as="th">Förening</Table.Col>
          <Table.Col as="th">Kroppsvikt</Table.Col>
          <Table.Col as="th">Resultat</Table.Col>
          <Table.Col as="th">Datum</Table.Col>
        </Table.Row>
      </Table.Head>

      <Table.Body>
        {isLoading ? <Table.Loading cols={6} /> : results.map(result => <Row result={result} key={result.id} />)}
      </Table.Body>
    </Table>
  );
}
